<template>
  <div>
    <div v-if="uiTexts">
      <v-card class="app text-center" outlined>
        <v-card-title>
          <v-img :src="uiConfig.logo" width="5em" class="image"></v-img>
        </v-card-title>
        <v-card-text>{{ uiTexts.infoTextTokenExpired }}</v-card-text>
        <v-card-actions>
          <v-btn @click="sendEmailClick" :loading="sendClickState.loading">{{ uiTexts.resendEmailLabel }}</v-btn>
        </v-card-actions>
        <div>
          <v-alert v-model="sendClickState.error" type="error">{{ uiTexts.resendEmailError }} </v-alert>
          <v-alert v-model="sendClickState.response" type="success">{{ uiTexts.resendEmailSuccess }}</v-alert>
        </div>
      </v-card>
      <v-footer v-if="uiTexts && uiConfig">
        <v-col class="text-center">
          <span v-html="uiConfig.aboutText"></span>
          <br />
          <br />
          <span v-html="uiConfig.poweredByText"></span>
        </v-col>
      </v-footer>
    </div>
    <template v-else-if="!uiTexts && tokenError">
      <div v-if="tokenError" class="text-center">
        <h1>{{ tokenErrorText.title }}</h1>
        <div>{{ tokenErrorText.text }}</div>
      </div>
    </template>
    <loader v-else></loader>
  </div>
</template>

<script>
/* eslint-disable */
import gql from "graphql-tag";
import jwt from "jsonwebtoken";
export default {
  apollo: {
    Config: {
      query: gql`
        # Write your query or mutation here
        query ResendData($locale: String, $mandator: String!) {
          Config(mandator: $mandator, locale: $locale) {
            logo
            url
            favicon
            aboutText
            poweredByText
            texts {
              title
              pageTitle
              customerName
              infoTextTokenExpired
              resendEmailLabel
              resendEmailSuccess
              resendEmailError
            }
          }
        }
      `,
      variables() {
        // Use vue reactive properties here
        return {
          locale: this.locale,
          mandator: this.mandator,
        };
      },
      result() {
        setTimeout(() => this.$emit("updateHead"), 100);
      },
    },
  },
  data() {
    return {
      locale: null,
      sendClickState: {
        error: null,
        loading: false,
        response: false,
      },
      mandator: null,
      token: null,
      token_data: null,
      tokenError: false,
    };
  },
  head: {
    title: function () {
      if (this.uiTexts) {
        return {
          inner: this.uiTexts.pageTitle || this.uiTexts.title || "",
          separator: "",
          complement: this.uiTexts.customerName,
        };
      }
    },
  },
  watch: {
    Config() {
      if (this.uiConfig) this.$setIcon(this.uiConfig.favicon);
    },
  },
  computed: {
    uiTexts() {
      if (this.Config) return this.Config.texts;
    },
    uiConfig() {
      if (this.Config) return this.Config;
    },
    tokenErrorText() {
      switch (this.locale) {
        case "de":
          return {
            title: "Ein Fehler ist aufgetreten",
            text: "Es scheint ein Problem mit dem Link zu geben. Bitte versuchen Sie es später erneut.",
          };
          break;
        default:
          //english
          return {
            title: "An error occured",
            text: "There is a problem with the link. Please try again later.",
          };
      }
    },
  },
  methods: {
    pushToResend() {
      this.$router.push({ path: "resend", query: { jwt: this.token } });
    },
    async sendEmailClick() {
      this.sendClickState = {
        error: null,
        loading: true,
        response: false,
      };
      if (this.token) {
        try {
          var res = await this.axios.post("api/email/resend", null, {
            headers: {
              Authorization: "Bearer " + this.token,
            },
          });
          this.sendClickState.response = true;
        } catch (e) {
          console.error(e);
          this.sendClickState.error = true;
        }
      } else {
        this.sendClickState.error = true;
      }
      this.sendClickState.loading = false;
    },
  },
  created() {
    this.token = this.$route.query.jwt;
    this.locale = localStorage.locale || navigator.language;

    if (this.locale.length > 2) {
      this.locale = this.locale.split("-")[0];
    }

    if (!this.token) {
      this.tokenError = true;
    } else {
      try {
        this.$set(this, "token_data", jwt.decode(this.token));
        this.mandator = this.token_data.mandator || this.token_data.mndt;
      } catch (e) {
        this.tokenError = true;
      }
    }
  },
};
</script>
<style>
.app {
  margin-top: 5em;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1em;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: fit-content;
  padding: 5em;
}

.v-footer {
  background-color: #efefef;
  flex: 0 0 50px;
  /*or just height:50px;*/
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
}
</style>
